import { createSlice } from "@reduxjs/toolkit"
import { ListingStateInterface } from "../../utils/constants/Interfaces.constants"

const initialState:ListingStateInterface = {
    listingData: [],
    selectedFilterID: ''
}

const APIListingSlice = createSlice({
    name: 'APIListing',
    initialState,
    reducers: {
        setListingData: (state, action) => {
            state.listingData = action.payload
        },
        setSelectedFilterID: (state, action) => {
            state.selectedFilterID = action.payload
        }
    }
})

export const { setListingData, setSelectedFilterID } = APIListingSlice.actions
export default APIListingSlice.reducer
